export default __webpack_public_path__ + "static/media/image30.b6c7fd74.svg";